module.exports = __webpack_public_path__ + "img/kurt.da187d5a.jpg";